<template>
  <div class="home">
    <div id="carouselExampleCaptions" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active card bg-dark text-white">
          <img src="../assets/slide1.png" height=240 class="card-img" alt="...">
          <div class="card-img-overlay">
            <h5 class="card-title">リベルタ料理 リベルタ</h5>
            <p class="card-text">お問い合わせ : 052-848-1070</p>
            <p class="card-text">営業時間 : 11：00～15：00, 17：30～22：30</p>
          </div>
        </div>
        <div class="carousel-item card bg-dark text-white">
          <img src="../assets/slide2.jpg" height=240 class="card-img" alt="...">
          <div class="card-img-overlay">
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
    <div id="newslist">
      <div class="lead">
        <h5>
          お知らせ
          <router-link to="/notice"><small class="text-muted pull-right">もっと>></small></router-link>
        </h5>
      </div>
      <div v-for="item in items.slice(0, 4)" :key="item.text" class="card">
        <div class="card-body" v-on:click="toDetails(item)">
          <p class="card-text">{{ item[1] }}<br><small class="text-muted pull-right">{{ item[9] }}</small></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sx from '../utils/core.js'

export default {
  created() {
    this.$store.state.title = '店舗アプリ'
    this.$store.state.pageBack = 'Home'
  },
  data() {
    return {
      items: [],
      searchOpt: {
        kbn: '00',
        category: '20'
      }
    }
  },
  mounted() {
    sx.showWaiting()
    const that = this

    var params = {
      bucketid: '17',
      options: JSON.stringify(that.searchOpt),
      token: localStorage.getItem('token') || 'token'
    }
    var url = that.$store.state.baseurl + '/app/cmshelper/fetchPostList'
    sx.request(
      url,
      params,
      function (result) {
        if (result.status === 'ok') {
          that.items = result.data.rows
        } else {
          sx.toastSuccess(result.message)
          console.log(result.message)
        }
        sx.hideWaiting()
      },
      function () {
        sx.login(
          url,
          params,
          function (result) {
            if (result.status === 'ok') {
              that.items = result.data.rows
            } else {
              sx.toastSuccess(result.message)
              console.log(result.message)
            }
            sx.hideWaiting()
          }
        )
      }
    )
  },
  methods: {
    toDetails(item) {
      localStorage.setItem('itemDetails', JSON.stringify(item))
      this.$router.replace({ name: 'Details' })
    }
  }
}
</script>
<style>
#newslist {
  margin: 4px;
}

#newslist .card {
  text-align: left;
  margin-top: 6px;
}

#newslist .card .card-body {
  padding: 10px;
}

small {
  color: #fb6e14;
}

.lead {
  padding-top: 20px;
  text-align: left;
  color: #fb6e14;
}

.home {
  padding: 4px;
}
</style>
